import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {FaqComponent} from './faq.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.faq.pageInRouting,
    data: {data: PAGES_AND_PATHS.faq},
    component: FaqComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./faq.module').then(m => m.FaqModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaqRoutingModule { }
